import axios from 'axios';
import { store } from '../store';
import { logout } from '../actions/authorizationAction';
import { NotificationManager } from 'react-notifications';

class AxiosHelper {
    static init() {
        axios.interceptors.request.use((request) => {
            if (!request) {
                return request;
            }

            let token = store.getState().authorization.accessToken;
            let projectId;
            if (store.getState().project.selectedProject) {
                projectId = store.getState().project.selectedProject.id;
            }

            if (projectId && (request.url.search(/\/backend\/project\/overview/) !== -1 ||
                request.url.search(/translation|\/backend\/user|\/backend\/users|login|\/backend\/scope|\/backend\/project|\/backend\/projects/) === -1 ||
                request.url.search(/\/backend\/projectStats/) !== -1)) {

                if (request.url[request.url.length - 1] !== '/') {
                    request.url += '/';
                }
                request.url += projectId;
            }

            if (token) {
                request.headers['Authorization'] = `Bearer ${token}`;
            }

            request.validateStatus = function (status) {
                return (status >= 200 && status < 300) || status === 404;
            };

            return request;
        });

        axios.interceptors.response.use(
            (response) => response, // Handle valid responses
            (error) => {
                if (error.response && error.response.status === 401) {
                    store.dispatch(logout());
                } else {
                    if (error.config?.url?.indexOf('/tablet/') === -1) {
                        NotificationManager.error('Please try again or contact administrators.', 'Server error', 10000);
                    }
                }
                return Promise.reject(error);
            }
        );
    }
}

export default AxiosHelper;
